import React from 'react';
import css from './css/StudentSurveyAudience.scss';
import classnames from "classnames";
import commonCss from "./css/SurveyStyle.scss";
import {getWord} from "utils/tenant";
import LabelledRadioOption from "common/LabelledRadioOption";
import PropTypes from "prop-types";
import {CohortDropdown} from "SF/CohortDropdown";

function StudentSurveyAudienceStep({audience, editable, setProperties}) {
    const studentSurveyCustomLanguage = getWord('studentSurvey', false)

    const cohortsSection = () =>
        <div className={css['cohorts-section']}>
            <h3 className={commonCss['header-third-level']}>Specify Cohorts</h3>
            <div className={classnames(commonCss['instructional-text'], commonCss['spacing-below'], css['space-above'])}>
                Add up to 10 cohorts. If you add more than 1 cohort then students that are in any of the cohorts will be included.
                Don&apos;t see the cohort you are looking for? To create a cohort, save this {studentSurveyCustomLanguage} and
                navigate to the Cohorts tab within <span className={commonCss['bold']}>Users &amp; Roles</span>.
            </div>
            <div className={commonCss['instructional-text']}>
                <span className={commonCss['required-asterisk']}>*</span> Required Fields
            </div>
            <div className={css['cohort-selection']}>
                <label htmlFor="surveyCohortDropdown" className={classnames(commonCss['instructional-text'], commonCss['bold'])}>
                    <span aria-hidden className={commonCss['required-asterisk']}>*</span>
                    Cohorts
                </label>
                <CohortDropdown id="surveyCohortDropdown"
                                defaultCohortIds={audience?.cohortIds || []}
                                onBlur={(cohorts) => {setProperties({audience: {cohortIds: cohorts}})}}
                                onChange={(cohorts) => {setProperties({audience: {cohortIds: cohorts}})}}
                                maxCohortCount={10}
                                disabled={!editable}
                />
            </div>
        </div>

    const isCohortRadioOptionChecked = () =>
        !!audience && audience.allStudents === false

    return (
        <>
            <h2 className={commonCss['header-second-level']}>Audience</h2>
            <div className={classnames(commonCss['instructional-text'], commonCss['spacing-below'])}>
                This page cannot be modified after this {studentSurveyCustomLanguage} is scheduled.
            </div>
            <div className={classnames(commonCss['instructional-text'], commonCss['bold'], css['space-below'])}>
                Specify students who should receive this {studentSurveyCustomLanguage}:
            </div>
            <LabelledRadioOption
                isChecked={!!audience && audience.allStudents}
                customClass={css['radio-button']}
                label="All Students"
                labelId="allStudents"
                onRadioSelect={() => { setProperties({audience: { allStudents: true, cohortIds: null }}) }}
                radioGroupName="surveyAudience"
                disabled={!editable} />
            <LabelledRadioOption
                isChecked={isCohortRadioOptionChecked()}
                customClass={css['radio-button']}
                label="Specific Cohorts"
                labelId="cohorts"
                onRadioSelect={() => { setProperties({audience: { allStudents: false }}) }}
                radioGroupName="surveyAudience"
                disabled={!editable} />
            {isCohortRadioOptionChecked() && cohortsSection()}
        </>
    )
}

StudentSurveyAudienceStep.propTypes = {
    audience: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    editable: PropTypes.bool.isRequired,
    setProperties: PropTypes.func.isRequired
}

export default StudentSurveyAudienceStep;
